export type Themes =
  | "white"
  | "lightWhite"
  | "grey"
  | "lightGrey"
  | "black"
  | "danger"
  | "warning"
  | "primary"
  | "info"
  | "yellow"
  | "red"
  | "pink"
  | "mineShaft";

export type BaseStyleAttrs = {
  width?: string;
  height?: string;
  padding?: string;
  margin?: string;
};

type Theme = { main: { [T in Themes]: string } };

const theme: Theme = {
  main: {
    white: "#ffffff",
    lightWhite: "#fafafa",
    grey: "#999999",
    lightGrey: "#eee",
    primary: "#035D97",
    black: "#011326",
    danger: "#D3212C",
    warning: "#ff3801",
    info: "#008BAC",
    yellow: "#FFE387",
    red: "#ff0000",
    pink: "#ffc7c7",
    mineShaft: "#333333",
  },
};

export const switchColor = (color: Themes) => {
  switch (color) {
    case "primary":
      return theme.main.primary;
      break;
    case "info":
      return theme.main.info;
      break;
    case "danger":
      return theme.main.danger;
      break;
    case "warning":
      return theme.main.warning;
      break;
    default:
      return theme.main.grey;
  }
};

export default theme;
